export const purchaseFinanceOptions = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorFinalPrice',
  'configuratorGenre',
  'configuratorProductCode',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const purchaseDetails = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorFinalPrice',
  'configuratorGenre',
  'configuratorProductCode',
  'financeProduct',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const purchaseDealer = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorFinalPrice',
  'configuratorGenre',
  'configuratorProductCode',
  'financeProduct',
  'tradeIn',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

export const purchaseConfirmed = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorFinalPrice',
  'configuratorGenre',
  'configuratorProductCode',
  'financeProduct',
  'tradeIn',
  'dealerName',
  'configuratorExtraName',
  'configuratorExtraPrice',
  'offerPresent',
  'offerName',
];

// eslint-disable-next-line prettier/prettier
export const financeSelection = [
  'countryMarket',
  'financeProduct',
];

// eslint-disable-next-line prettier/prettier
export const purchaseQteOpen= [
  'countryMarket',
  'financeProduct',
  'offerPresent',
  'offerName',
];

// eslint-disable-next-line prettier/prettier
export const purchaseQteClose = [
  'countryMarket',
  'financeProduct',
  'offerPresent',
  'offerName',
];

// eslint-disable-next-line prettier/prettier
export const purchaseQteRemove = [
  'countryMarket',
  'financeProduct',
  'offerPresent',
  'offerName',
];

// eslint-disable-next-line prettier/prettier
export const purchaseQteEdit = [
  'countryMarket',
  'financeProduct',
  'offerPresent',
  'offerName',
];

// eslint-disable-next-line prettier/prettier
export const purchaseOffOpen = [
  'countryMarket',
  'financeProduct',
  'offerPresent',
  'offerName',
];

// eslint-disable-next-line prettier/prettier
export const dealerSelected = [
  'countryMarket',
  'dealerName',
];

// eslint-disable-next-line prettier/prettier
export const journeyLine = [
  'countryMarket',
  'sectionEdit',
];

// eslint-disable-next-line prettier/prettier
export const editLink = [
  'countryMarket',
  'sectionEdit',
];

export const visitDealer = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorFinalPrice',
  'configuratorGenre',
  'configuratorProductCode',
  'financeProduct',
  'tradeIn',
  'dealerName',
];

export const getDirections = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorFinalPrice',
  'configuratorGenre',
  'configuratorProductCode',
  'financeProduct',
  'tradeIn',
  'dealerName',
];

export const saveQuoteCancel = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorFinalPrice',
  'configuratorGenre',
  'configuratorProductCode',
  'financeProduct',
];

export const saveQuoteComplete = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorFinalPrice',
  'configuratorGenre',
  'configuratorProductCode',
  'financeProduct',
];

export const purchaseCal = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorFinalPrice',
  'configuratorGenre',
  'configuratorProductCode',
  'financeProduct',
  'offerPresent',
  'offerName',
  'ctaText',
];

export const purchaseCalPrim = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorFinalPrice',
  'configuratorGenre',
  'configuratorProductCode',
  'financeProduct',
  'offerPresent',
  'offerName',
  'ctaText',
];

export const purchaseCalSec = [
  'countryMarket',
  'configuratorBikeName',
  'configuratorBikeID',
  'configuratorBikeYear',
  'configuratorFinalPrice',
  'configuratorGenre',
  'configuratorProductCode',
  'financeProduct',
  'offerPresent',
  'offerName',
  'ctaText',
];
